import React, { useEffect, useState } from "react";
import Header from "./HostelHeader";
import Nav from "../master/NavBar";
import Footer from "../main/footer";
import { closeModal, ToastMain ,SweetAlertShow} from "../master/Master";
import { Link, useLocation } from "react-router-dom";
import {
  CreateHostel,
  DeleteHostelData,
  GetHostelList,
  StatusChange,
  UpdateHostel,
} from "../../api/HostelService";
import Swal from "sweetalert2";
import WelcomeBar from "./WelcomeBar";

export default function Hostels() {
  const [loading, setLoading] = useState(false);
  const [hostels, setHostels] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [modalData, setModalData] = useState("");
  const [error, setError] = useState("");

  const getHostelList = async () => {
    setLoading(true);
    let addUrl = `&page=${page}`;
    if (search) addUrl += `&search=${search}`;
    try {
      const response = await GetHostelList(addUrl);
      if (response.data?.status) {
        setHostels(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHostelList();
  }, [page, search]);

  const createHostel = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await CreateHostel(formData);
      if (response?.data?.status) {
        setError('');
        e.target.reset();
        closeModal("addNewHostel");
        getHostelList();
        ToastMain.fire({
          icon: "success",
          title: "created successfully!",
        });
      } else {
        if (response?.data?.message == "Validation error") {
          setError(response?.data?.errors);
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError( error?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error', error?.response?.data?.message ?? error?.response?.message  ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id) => {
    setLoading(true);
    try {
      const response = await StatusChange(id);
      if (response?.data?.status) {
        getHostelList();
        ToastMain.fire({
          icon: "success",
          title: "Successfully",
        });
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  const updateHostel = async (e) => {
    setLoading(true)
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await UpdateHostel(formData);
      if (response?.data?.status) {
        setError('')
        closeModal("editHostel");
        getHostelList();
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        });
      } else {
        if(response?.data?.errors){
          setError(response?.data?.errors)
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
        SweetAlertShow('info','Warning', response?.data?.message)
      }
    } catch (error) {
        if(error?.response?.data?.errors){
          setError(error?.response?.data?.errors)
        }
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  const deleteHostel = async (id) => {
    setLoading(true);
    try {
      const response = await DeleteHostelData(id);
      if (response?.data?.status) {
        getHostelList();
        ToastMain.fire({
          icon: "success",
          title: "Successfully!",
        });
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.response?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
              <WelcomeBar/>
                <div className="card my-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                      <h4 className="text-primary mb-0">Hostels</h4>
                      <button
                        className="btn btn-label-primary btn-sm"
                        data-bs-toggle="modal"
                        data-bs-target="#addNewHostel"
                      >
                        + ADD New Hostel
                      </button>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search By Name"
                          />
                          <label htmlFor="">Search </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <button
                          onClick={() => setSearch("")}
                          className="btn btn-sm btn-label-danger"
                        >
                          <i className="ri ri-restart-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card my-3">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr className="text-center text-nowrap">
                            <th>#</th>
                            <th>Hostel Name</th>
                            <th>Address</th>
                            <th>Total Students</th>
                            <th>Total Rooms</th>
                            <th>Contact No</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hostels?.data?.map((hostel, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className="text-primary fw-semibold">
                                {hostel.name}
                              </td>
                              <td>{hostel?.address}</td>
                              <td>{hostel?.students_count}</td>
                              <td>{hostel?.rooms_count}</td>
                              <td>{hostel?.mobile}</td>
                              <td>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input fs-5 "
                                    type="checkbox"
                                    role="switch"
                                    id="switchCheckDefault"
                                    checked={hostel?.status == "1" && true}
                                    onChange={() =>
                                      handleStatusChange(hostel?.id)
                                    }
                                  />
                                </div>
                              </td>

                              <td>
                                <button
                                  onClick={() => {
                                    setModalData(hostel);
                                  }}
                                  className="btn btn-label-info btn-sm me-2"
                                  data-bs-toggle="modal"
                                  data-bs-target="#editHostel"
                                >
                                  <i className="bi bi-pencil-square"></i>{" "}
                                </button>

                                <button
                                  className="btn btn-label-danger btn-sm me-2"
                                  onClick={() =>
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "This action will permanently delete !",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#d33",
                                      cancelButtonColor: "#6c757d",
                                      confirmButtonText: "Yes, delete it!",
                                      cancelButtonText: "Cancel",
                                    }).then(async (result) => {
                                      if (result.isConfirmed) {
                                        deleteHostel(hostel?.id);
                                      }
                                    })
                                  }
                                >
                                  <i className="bi bi-trash-fill"></i>{" "}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <nav aria-label="Page navigation" className="mt-10">
                        <p>
                          Showing {hostels?.from} to {hostels?.to} of{" "}
                          {hostels?.total} entries
                        </p>
                        <ul className="pagination pagination-sm">
                          {hostels?.links?.map((btn, i) => (
                            <li
                              className={`page-item  ${
                                btn?.active && "active"
                              }  ${btn?.url ? "" : "disabled"} `}
                            >
                              <button
                                className="page-link waves-effect"
                                onClick={() => {
                                  if (hostels?.links?.length === i + 1) {
                                    btn?.url &&
                                      setPage(hostels?.current_page + 1);
                                  } else if (i === 0) {
                                    btn?.url &&
                                      setPage(hostels?.current_page - 1);
                                  } else {
                                    setPage(btn.label);
                                  }
                                }}
                              >
                                {hostels?.links?.length == i + 1 ? (
                                  <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                ) : i == 0 ? (
                                  <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                ) : (
                                  btn?.label
                                )}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addNewHostel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={createHostel}>
              <div className="modal-header bg-label-primary py-3 ">
                <h1 className="modal-title fs-5">Add Hostel</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    placeholder="Enter Hostel Name"
                    name="name"
                  />
                  <label className="">Hostel Name</label>
                  <span className="text-danger"> {error?.name??''}</span>
                </div>

                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Contact Number"
                    name="mobile"
                  />
                  <label className="">Contact No</label>
                  <span className="text-danger"> {error?.mobile??''}</span>
                </div>
                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <textarea
                    className="form-control input-uppercase"
                    rows="2"
                    placeholder="Enter Hostel Address"
                    name="address"
                  ></textarea>
                  <label className="">Address</label>
                  <span className="text-danger"> {error?.address ??''}</span>
                </div>
              </div>
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} 
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editHostel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-3">
              <h3 className="modal-title fs-5" id="exampleModalLabel">
                Edit Hostel
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form className="row g-3 p-3" onSubmit={updateHostel}>
                <input type="hidden" name="id" value={modalData?.id} />
                <div className="col-md-6 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    placeholder="Enter Hostel Name"
                    name="name"
                    defaultValue={modalData?.name}
                  />
                  <label className="">Hostel Name</label>
                  <span className="text-danger">{error?.name ?? ''}</span>
                </div>

                <div className="col-md-6 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Contact Number"
                    name="mobile"
                    defaultValue={modalData?.mobile}
                  />
                  <label className="">Contact No</label>
                  <span className="text-danger">{error?.mobile ?? ''}</span>

                </div>

                <div className="col-md-6 form-floating form-floating-outline">
                  <textarea
                    className="form-control input-uppercase"
                    rows="5"
                    placeholder="Enter Hostel Address"
                    name="address"
                    defaultValue={modalData?.address}
                  />
                  <label className="">Address</label>
                  <span className="text-danger">{error?.address ?? ''}</span>

                </div>

                <div className="modal-footer">
                 <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}  
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
